import React from 'react';
import PriceRange from '@components/catalog/price-range/price-range';
import useFormatPrice from '@hooks/use-format-price-hook';
import { usePreferences } from '@context/preferences.context';
import { CatalogContext } from '@context/catalog.context';
import { useContextSelector } from 'use-context-selector';

export type PriceRangeItemProps = {
  onSubmit?: (min: number, max: number) => void;
};

const PriceRangeItem: React.FC<PriceRangeItemProps> = (props) => {
  const { onSubmit } = props;
  const { formatPrice, convertFromCents, convertToCents } = useFormatPrice();
  const { currency, language } = usePreferences();

  const priceBound = useContextSelector(CatalogContext, (v) => v.priceBound);
  const priceFilter = useContextSelector(CatalogContext, (v) => v.filters?.price) ?? {};

  return (
    <PriceRange
      range={{
        from: formatPrice(convertFromCents(priceBound.lower), currency, language),
        to: formatPrice(convertFromCents(priceBound.upper), currency, language),
      }}
      currentPriceFilter={{
        min: priceFilter['>='] ? convertFromCents(priceFilter['>=']) : null,
        max: priceFilter['<='] ? convertFromCents(priceFilter['<=']) : null,
      }}
      onSubmit={(min, max) => onSubmit(convertToCents(min), convertToCents(max))}
    />
  );
};

export default PriceRangeItem;
